export const FAST_BUZZER_PHASES = [
    "LOBBY",
    "PREPARATION",
    "WAITING_RANDOM",
    "ACTIVE",
    "ROUND_RESULT",
    "PAUSED",
    "FINISHED"
];
const transitions = {
    START: ["LOBBY"],
    PREPARATION_COMPLETE: ["PREPARATION"],
    GO: ["WAITING_RANDOM"],
    BUZZ: ["ACTIVE"],
    FALSE_START: ["PREPARATION", "WAITING_RANDOM"],
    ROUND_COMPLETE: ["ACTIVE", "WAITING_RANDOM"],
    NEXT_ROUND: ["ROUND_RESULT"],
    FINISH: ["ROUND_RESULT"],
    PAUSE: ["PREPARATION", "WAITING_RANDOM", "ACTIVE", "ROUND_RESULT"],
    RESUME: ["PAUSED"],
    SKIP_ROUND: ["PREPARATION", "WAITING_RANDOM", "ACTIVE"],
    END: ["LOBBY", "PREPARATION", "WAITING_RANDOM", "ACTIVE", "ROUND_RESULT", "PAUSED"],
    PLAY_AGAIN: ["FINISHED"]
};
export function canTransitionFastBuzzer(phase, event) {
    return transitions[event].includes(phase);
}
export function transitionFastBuzzer(phase, event, options = {}) {
    if (!canTransitionFastBuzzer(phase, event))
        throw new Error(`INVALID_TRANSITION:${phase}:${event}`);
    switch (event) {
        case "START":
        case "NEXT_ROUND":
            return "PREPARATION";
        case "PREPARATION_COMPLETE":
            return "WAITING_RANDOM";
        case "GO":
        case "BUZZ":
            return "ACTIVE";
        case "FALSE_START":
            return phase;
        case "ROUND_COMPLETE":
        case "SKIP_ROUND":
            return "ROUND_RESULT";
        case "PAUSE":
            return "PAUSED";
        case "RESUME":
            if (!options.resumePhase)
                throw new Error("RESUME_PHASE_REQUIRED");
            return options.resumePhase;
        case "FINISH":
        case "END":
            return "FINISHED";
        case "PLAY_AGAIN":
            return "LOBBY";
    }
}
export function scoreDeltaForDecision(decision, scoring) {
    switch (decision) {
        case "FIRST": return scoring.firstPlacePoints;
        case "SECOND": return scoring.secondPlacePoints;
        case "THIRD": return scoring.thirdPlacePoints;
        case "PARTICIPATION": return scoring.participationPoints;
        case "FALSE_START": return scoring.falseStartPenalty;
        case "NO_BUZZ": return 0;
    }
}
export function scoreDecisionForPlacement(place) {
    if (place === 1)
        return "FIRST";
    if (place === 2)
        return "SECOND";
    if (place === 3)
        return "THIRD";
    return "PARTICIPATION";
}
//# sourceMappingURL=fast-buzzer-machine.js.map